// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"82f47d13aef5b19a","860":"2a83e5025f81deeb","983":"4c740d6c3503a2e4"}[chunkId] + ".js";
};